<template>
    <fragment>
        <out-put-page
            title="Étude financière"
            sectionRef="charges_externes_c_a"
            v-on:page-updated="handleAfterRender"
            orientation="landscape"
            class="landscape"
        >
        </out-put-page>
    </fragment>
</template>

<script>
import Vue from "vue";
import OutPutPage from "../components/OutPutPage";
import DataTable from "../components/DataTable";
import * as utils from "@/utils.js";
import isEmpty from "lodash/isEmpty";

const pageContentHeight = 1050;
const OutPageComponent = Vue.extend(OutPutPage);
const TableComponent = Vue.extend(DataTable);

export default {
    components: {
        OutPutPage
        // DataTable
    },
    props: {
        chargesExternes: { type: Array, required: true },
        chiffreDAffaires: { type: Object, required: true },
        cpc: { type: Array, required: true },
        tauxEvolutionDesCharges: { type: [Number, String], required: true },
        achatsPrevisionnels: { type: Object, required: true }
    },
    data() {
        return {
            data: [],
            renderTrigger: ""
        };
    },
    mounted() {
        const chargeExternes = this.initChargeExternesTable();
        const chiffreDaffaire = this.initChiffreAffaire();
        const achatPrevisionnel = this.initAchatPrevisionnel();

        const $vm = this;
        this.data.push(
            {
                data: chargeExternes,
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }

                    $vm.$nextTick(() => {
                        this.componentInstance.$props.tables.data.push(data);
                        this.currentPage.renderTrigger = utils.generateUID();
                        this.prevData = data;
                        this.data.shift();
                        if (this.isEmpty()) {
                            $vm.data.shift();
                        }
                    });
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.tables.data.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.componentInstance = new TableComponent({
                        propsData: {
                            tables: {
                                headers: [
                                    { title: "Désignation", type: "String" },
                                    {
                                        title: "Taux d'evolution",
                                        type: "String"
                                    },
                                    { title: "Montant", type: "Currency" }
                                ],
                                data: []
                            }
                        }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Étude financière",
                            sectionRef: "charges_externes_c_a",
                            orientation: "landscape"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    newPage.$el.classList.add("landscape");

                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.charges_externes_c_a.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const PartnersSection = document.createElement("section");
                    const PartnersSectionTitle = document.createElement("h3");
                    PartnersSectionTitle.innerHTML =
                        "Calcul des charges externes";
                    PartnersSection.classList.add("landscape");
                    PartnersSection.appendChild(PartnersSectionTitle);
                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            },
            {
                data: chiffreDaffaire,
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.tables.data.push(data);
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.tables.data.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const headers =
                        $vm.chiffreDAffaires.details.type !== "CA Détails"
                            ? [
                                  { title: "001", type: "Currency" },
                                  { title: "002", type: "Currency" },
                                  { title: "003", type: "Currency" },
                                  { title: "004", type: "Currency" },
                                  { title: "005", type: "Currency" },
                                  { title: "006", type: "Currency" },
                                  { title: "007", type: "Currency" },
                                  { title: "008", type: "Currency" },
                                  { title: "009", type: "Currency" },
                                  { title: "010", type: "Currency" }
                              ]
                            : [
                                  { title: "Article", type: "String" },
                                  { title: "Prix", type: "Currency" },
                                  { title: "Qte", type: "String" },
                                  { title: "001", type: "Currency" },
                                  { title: "002", type: "Currency" },
                                  { title: "003", type: "Currency" },
                                  { title: "004", type: "Currency" },
                                  { title: "005", type: "Currency" },
                                  { title: "006", type: "Currency" },
                                  { title: "007", type: "Currency" },
                                  { title: "008", type: "Currency" },
                                  { title: "009", type: "Currency" },
                                  { title: "010", type: "Currency" }
                              ];

                    this.componentInstance = new TableComponent({
                        propsData: {
                            tables: {
                                headers: headers,
                                data: []
                            }
                        }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Étude financière",
                            sectionRef: "charges_externes_c_a",
                            orientation: "landscape"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    newPage.$el.classList.add("landscape");
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.charges_externes_c_a.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const title =
                        $vm.chiffreDAffaires.details.type === "CA Détails"
                            ? "Calcul chiffre d'Affaires détaillé"
                            : " Calcul chiffre d'Affaires global ";
                    const PartnersSection = document.createElement("section");
                    const PartnersSectionTitle = document.createElement("h3");
                    PartnersSectionTitle.innerHTML = title;
                    // PartnersSection.classList.add("landscape");
                    PartnersSection.appendChild(PartnersSectionTitle);
                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            },
            {
                data: achatPrevisionnel,
                prevData: this.data[0],
                firstItemLock: true,
                seed(data = this.data[0]) {
                    if (this.isEmpty()) {
                        $vm.data.shift();
                        this.currentPage.renderTrigger = utils.generateUID();
                        return;
                    }
                    $vm.$nextTick(() => {
                        this.componentInstance.$props.tables.data.push(data);
                        this.currentPage.renderTrigger = utils.generateUID();
                    });
                    this.prevData = data;
                    this.data.shift();
                    if (this.isEmpty()) {
                        $vm.data.shift();
                    }
                },
                isEmpty() {
                    return isEmpty(this.data);
                },
                pop() {
                    this.componentInstance.$props.tables.data.pop();
                    this.data = [this.prevData, ...this.data];
                },
                componentInstance: "",
                initComponent() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const headers =
                        $vm.achatsPrevisionnels.details.type !== "details"
                            ? [
                                  { title: "001", type: "Currency" },
                                  { title: "002", type: "Currency" },
                                  { title: "003", type: "Currency" },
                                  { title: "004", type: "Currency" },
                                  { title: "005", type: "Currency" },
                                  { title: "006", type: "Currency" },
                                  { title: "007", type: "Currency" },
                                  { title: "008", type: "Currency" },
                                  { title: "009", type: "Currency" },
                                  { title: "010", type: "Currency" }
                              ]
                            : [
                                  { title: "Article", type: "String" },
                                  { title: "Prix", type: "Currency" },
                                  { title: "Qte", type: "String" },
                                  { title: "001", type: "Currency" },
                                  { title: "002", type: "Currency" },
                                  { title: "003", type: "Currency" },
                                  { title: "004", type: "Currency" },
                                  { title: "005", type: "Currency" },
                                  { title: "006", type: "Currency" },
                                  { title: "007", type: "Currency" },
                                  { title: "008", type: "Currency" },
                                  { title: "009", type: "Currency" },
                                  { title: "010", type: "Currency" }
                              ];

                    this.componentInstance = new TableComponent({
                        propsData: {
                            tables: {
                                headers: headers,
                                data: []
                            }
                        }
                    });
                },
                newPage() {
                    const newPage = new OutPageComponent({
                        propsData: {
                            title: "Étude financière",
                            sectionRef: "charges_externes_c_a",
                            orientation: "landscape"
                        }
                    });
                    newPage.$mount();
                    newPage.$on("page-updated", $vm.handleAfterRender);
                    newPage.$el.classList.add("landscape");
                    $vm.$children[
                        $vm.$children.length - 1
                    ].$refs.charges_externes_c_a.after(newPage.$el);
                    $vm.$children.push(newPage);

                    this.currentPage = $vm.$children[$vm.$children.length - 1];
                },
                currentPage: $vm.$children[$vm.$children.length - 1],
                initSection() {
                    this.currentPage = $vm.$children[$vm.$children.length - 1];

                    const title =
                        $vm.achatsPrevisionnels.details.type === "details"
                            ? "Calcul achats prévisionnels détaillé"
                            : "Calcul achats prévisionnels global";
                    const PartnersSection = document.createElement("section");
                    const PartnersSectionTitle = document.createElement("h3");
                    PartnersSectionTitle.innerHTML = title;
                    // PartnersSection.classList.add("landscape");
                    PartnersSection.appendChild(PartnersSectionTitle);
                    this.componentInstance.$mount();
                    PartnersSection.appendChild(this.componentInstance.$el);
                    this.currentPage.$refs.content.appendChild(PartnersSection);
                }
            }
        );

        this.handleAfterRender();
    },
    methods: {
        handleAfterRender(contentHeight) {
            for (const instance of this.data) {
                if (instance.firstItemLock && instance.data.length > 0) {
                    instance.firstItemLock = false;
                    instance.initComponent();
                    if (pageContentHeight - contentHeight < 300)
                        instance.newPage();
                    instance.initSection();
                }
                if (contentHeight >= pageContentHeight) {
                    instance.pop();
                    instance.initComponent();
                    instance.newPage();
                    instance.initSection();
                    instance.seed(instance.prevData);
                } else {
                    instance.seed();
                }
                break;
            }
        },
        initChargeExternesTable() {
            const keysOrder = ["name", "tauxEvolution", "value"];
            const chargeExternes = [];
            this.chargesExternes.forEach(item => {
                chargeExternes.push(
                    keysOrder.map(elem => {
                        if (elem === "tauxEvolution")
                            return this.tauxEvolutionDesCharges + " %";
                        return item[`${elem}`];
                    })
                );
            });
            return chargeExternes;
        },
        initAchatPrevisionnel() {
            const isDetailed =
                this.achatsPrevisionnels.details.type === "details";

            const achatsPrevisionnelsArray = isDetailed
                ? this.achatsPrevisionnels.details.achats
                : this.cpc;
            const keysOrder = ["name", "prixAchat", "quantite"];
            const achatsPrevisionnelsData = [];
            if (!isDetailed) {
                achatsPrevisionnelsData.push(
                    achatsPrevisionnelsArray.map(
                        item => item.achatsPrevisionnel
                    )
                );
                achatsPrevisionnelsData.push([
                    `Taux d’évolution: ${this.achatsPrevisionnels.tauxEvolution}%`
                ]);
            } else {
                achatsPrevisionnelsArray.forEach(item => {
                    achatsPrevisionnelsData.push(
                        keysOrder.map(elem => {
                            if (elem === "quantite")
                                return item[`${elem}`] + "/" + item.unite;
                            return item[`${elem}`];
                        })
                    );
                });
                const achatsPrevisionnelsCalc = this.achatsPrevisionnelDetaille();
                achatsPrevisionnelsData.forEach((item, index) => {
                    achatsPrevisionnelsData[index] = achatsPrevisionnelsData[
                        index
                    ].concat(achatsPrevisionnelsCalc[index]);
                });
                achatsPrevisionnelsData.push([
                    `Taux d’évolution: ${this.achatsPrevisionnels.tauxEvolution}%`
                ]);
            }

            return achatsPrevisionnelsData;
        },
        initChiffreAffaire() {
            const isDetailed =
                this.chiffreDAffaires.details.type === "CA Détails";
            const chiffreAffaireArray = isDetailed
                ? this.chiffreDAffaires.details.offersObject
                : this.cpc;

            const keysOrder = ["name", "price", "quantiteVente"];

            const chiffreAffaireData = [];
            if (!isDetailed) {
                const estimation = this.chiffreDAffaires.details.options
                    .map(option => option.name)
                    .join(", ");
                chiffreAffaireData.push(
                    chiffreAffaireArray.map(item => item.chifreAffaire)
                );
                chiffreAffaireData.push(
                    [
                        `Taux de réalisation: ${this.chiffreDAffaires.tauxRealisation}%`,
                        `Taux d’évolution: ${this.chiffreDAffaires.tauxEvolution}%`
                    ],
                    [
                        `L’estimation du CA prévisionnel a été faite en se basant
                    sur: ${estimation}`
                    ]
                );
            } else {
                chiffreAffaireArray.forEach(item => {
                    chiffreAffaireData.push(
                        keysOrder.map(elem => {
                            if (elem === "quantiteVente")
                                return item[`${elem}`] + "/" + item.units;
                            return item[`${elem}`];
                        })
                    );
                });
                const chiffreAffaireCalc = this.chiffreDaffaireDetaille();
                chiffreAffaireData.forEach((item, index) => {
                    chiffreAffaireData[index] = chiffreAffaireData[
                        index
                    ].concat(chiffreAffaireCalc[index]);
                });
                chiffreAffaireData.push([
                    `Taux de réalisation: ${this.chiffreDAffaires.tauxRealisation}%`,
                    `Taux d’évolution: ${this.chiffreDAffaires.tauxEvolution}%`
                ]);
            }

            return chiffreAffaireData;
        },
        chiffreDaffaireDetaille() {
            const arr = [...Array(10).keys()];
            if (this.chiffreDAffaires.details.offersObject === undefined)
                return 0;
            return this.chiffreDAffaires.details.offersObject.map(item => {
                let prevYear = 0;

                return arr.map((elem, i) => {
                    if (i === 0) {
                        if (item.date === "Mois")
                            return (prevYear +=
                                (item.price *
                                    item.quantiteVente *
                                    12 *
                                    this.chiffreDAffaires.tauxRealisation) /
                                100);
                        return (prevYear +=
                            (item.price *
                                item.quantiteVente *
                                this.chiffreDAffaires.tauxRealisation) /
                            100);
                    }
                    return (prevYear +=
                        (prevYear * this.chiffreDAffaires.tauxEvolution) / 100);
                });
            });
        },
        achatsPrevisionnelDetaille() {
            const arr = [...Array(10).keys()];
            if (this.achatsPrevisionnels.details.achats === undefined) return 0;
            return this.achatsPrevisionnels.details.achats.map(item => {
                let prevYear = 0;
                return arr.map((elem, i) => {
                    if (i === 0) {
                        if (item.date === "Mois")
                            return (prevYear +=
                                item.prixAchat * item.quantite * 12);
                        return (prevYear += item.prixAchat * item.quantite);
                    }
                    return (prevYear +=
                        (prevYear * this.achatsPrevisionnels.tauxEvolution) /
                        100);
                });
            });
        }
    }
};
</script>

<style></style>
